import { openPopup } from './popups'; 
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";


export const urlParams = () => {

	// Check to see if we're using any custom URL params on load (after a timeout so allow 3rd parties to load)
	setTimeout(() => {
		handleURLParamsFunctionality(window.location.href);
	},750);
	

	let allATags = document.querySelectorAll('a');
	allATags.forEach((aTag) => { //Loop through each and give it a onclick event listener

		let linkHref = aTag.getAttribute('href');
		if(linkHref){
			if (linkHref.indexOf("#") != -1) {
				aTag.addEventListener('click', (event) => {
					event.preventDefault();
					let targetEl = event.target.getAttribute('href');
					if(targetEl == null){
						targetEl = event.target.parentElement.getAttribute('href');
					}

					handleURLParamsFunctionality(targetEl);
					return false;
				});
			}
		}		
	});
}

urlParams();


function handleURLParamsFunctionality(href){
	
	//#scrollTo:ElementIDToScrollTo  |   Will either load the page and scroll to that element ID, or scroll on click
	//#book:LocationName     		 |   Will trigger the resevations popup. Add a location name to preselect that location
	//#popup:PopupID				 |   Will open a specific popup.
	

	if (href.indexOf("#") != -1) { //Check if the link has a #
		let hashRaw = href.split('#')[1], 
			hashValue = hashRaw.split(':');

			console.log(hashValue[0]);

		if(hashValue[0] == 'book'){	//Shortcut to open booking widget

			openPopup('#reservations');

		}else if(hashValue[0] == 'scrollTo'){ //Scroll to the element!

			let scrollToLinks = document.querySelector('.scroll-to-links');
    		let scrollToLinksHeight = scrollToLinks ? scrollToLinks.offsetHeight : 0;
			
			let elementToScrollTo = document.querySelector('#' + hashValue[1]);
			if(elementToScrollTo){
				locationPageSubnavs = document.querySelectorAll(".m__lsubnav");
				if(locationPageSubnavs){
					document.querySelector("#js__body").classList.remove('js__popup-active');
					locationPageSubnavs.forEach((subnav) => {
						subnav.classList.remove('open');
					});
				}
				
				gsap.registerPlugin(ScrollToPlugin);
				gsap.to(window, {
					duration: 1, 
					scrollTo: {
		                y: elementToScrollTo, // Scroll to the element
		                offsetY: scrollToLinksHeight + 72 // Adjust for the height of scroll-to-links
		            }
				});
			}
		}else if(hashValue[0] == 'popup'){ //Open a custom popup

			if(hashValue[1] != null && hashValue[1] > ''){
				openPopup('#'+hashValue[1]);
			}

		} else if(hashValue[0] == 'trade-form'){ //Open a custom popup

			document.querySelector(".trade-form").classList.add('open');

		}else{
			return false;
		}

	}
}
